import React, { lazy } from 'react';
import mustache from 'mustache';
import { message } from 'antd';
import { store } from './redux/store';
import posthog from 'posthog-js';
import moment from 'moment';

export const sortByTime = field => (a, b) =>
	new Date(a[field || 'updated_at']) - new Date(b[field || 'updated_at']);

export const getAliasSignedUrl = url => {
	const baseUrl = 'storage.googleapis.com/bluebird-media-';
	const isProduction = url.includes('media-production') ? true : false;
	const newAlias = isProduction ? 'media.bpdev.club' : 'mediastaging.bpdev.club';
	const oldAlias = isProduction ? `${baseUrl}production` : `${baseUrl}staging`;
	const aliasedUrl = url.replace(oldAlias, newAlias);
	return aliasedUrl;
};
export function swapArrayElements(arr, i, j) {
	const b = arr[j];
	arr[j] = arr[i];
	arr[i] = b;
	return arr;
}

export function combineItems(arr, i, j) {
	const a = arr[i];
	const b = arr[j];
	const container = {
		component: 'View',
		props: {
			styleName: 'horizontal flexible',
		},
		children: [a, b],
	};
	arr.splice(j, 1);
	arr[i] = container;
	return arr;
}

export function childArrayFromPointer(array, pointers) {
	if (!pointers.length) return array;
	return childArrayFromPointer(array[pointers[0]], pointers.slice(1, pointers.length));
}

/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = path => {
	return reg.test(path);
};

export const urlToList = url => {
	const urllist = url.split('/').filter(i => i);
	return urllist.map((urlItem, index) => {
		return `/${urllist.slice(0, index + 1).join('/')}`;
	});
};

export function getDnDListStyle(isDragging, otherStyle) {
	return {
		...otherStyle,
		display: 'flex',
		flex: 1,
		backgroundColor: isDragging ? 'lightgreen' : 'transparent',
	};
}

export const GetURLParamValue = key => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	return urlParams.get(key);
};

export function getDnDItemStyle(isDragging, draggableStyle, otherStyle) {
	return {
		// some basic styles to make the items look a bit nicer
		attendeeSelect: 'none',
		// change background colour if dragging
		background: isDragging ? 'lightblue' : 'transparent',
		outline: isDragging ? '3px solid lightblue' : 'transparent',
		// styles we need to apply on draggables
		...draggableStyle,
		...otherStyle,
	};
}

// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

export const move = (source, destination, droppableSource, droppableDestination) => {
	const sourceClone = Array.from(source);
	const destClone = Array.from(destination);
	const [removed] = sourceClone.splice(droppableSource.index, 1);

	destClone.splice(droppableDestination.index, 0, removed);

	return [sourceClone, destClone];
};

export const metadataInject = (eventInfo, metadata) => {
	let result = eventInfo;
	const replacements = { '&lt;': '<', '&gt;': '>', '&#x2F;': '/' };

	if (metadata) {
		if (eventInfo && eventInfo.toString().indexOf('{{') > -1) {
			result = mustache.render(eventInfo, metadata);
			//unescapes html to render '/' correctly if metadata tag render to url
			if (result.includes('https')) result = mustache.render(`{${eventInfo}}`, metadata);
			result = result.replaceAll(/&lt;|&gt;|&#x2F;/g, matched => replacements[matched]);
		} else result = eventInfo;
	}

	return result;
};

export const isPPTorCSV = fileType => {
	const secondaryType = fileType && fileType.split('/')[1];
	return secondaryType.includes('csv') || secondaryType.includes('presentation');
};

export const getFileProps = ({
	signedUrlEndpoint,
	callback,
	listType = 'picture',
	multiple = false,
	isMedia = false,
	isFile = false,
	mimeType,
	mediaType,
}) => ({
	name: 'file',
	multiple,
	listType,
	accept: mimeType,
	maxCount: !multiple ? 1 : undefined,
	beforeUpload: file => {
		if (mediaType === 'ATTENDEE_MATERIAL' && isPPTorCSV(file.type)) {
			message.error('File type not accepted');
			return false;
		}
		if (file.type === 'image/heic') {
			message.error('We do not support HEIC images');
			return false;
		}
		if (!isMedia && !isFile) {
			const isImage = file.type.includes('image/');
			if (!isImage) {
				message.error('You can only upload image file!');
			}
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				message.error('Image must smaller than 2MB!');
			}
			return isImage && isLt2M;
		} else return isMedia || isFile;
	},
	onChange: info => {
		let status = info.file.status;
		if (status === 'uploading') {
			const uploaded = info.file.percent;
			if (uploaded === 100) {
				info.file.status = 'done';
				status = 'done';
			}
		}
		if (status === 'done') {
			//message.success(`${info.file.name} file uploaded successfully.`);
		} else if (status === 'error') {
			message.error(`${info.file.name} file upload failed.`);
		}
	},

	customRequest: imgCustomReq(signedUrlEndpoint, callback),
});
export const getSignedURL = signedURL => async file => {
	const { auth0Token } = store.getState().auth;
	try {
		const resp = await fetch(signedURL, {
			method: 'PUT',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${auth0Token}`,
			},
			body: JSON.stringify({
				name: new Date().getTime() + encodeURI(file.name),
				content_type: file.type,
			}),
		});
		const media = await resp.json();
		if (!media.signed_url) throw media;
		return media.signed_url;
	} catch (e) {
		console.error(e);
	}
};

export const imgCustomReq = (signedUrlEndpoint, callback = undefined) => async utils => {
	const { file, onError, onProgress, onSuccess } = utils;
	try {
		const signedUrl = await getSignedURL(signedUrlEndpoint)(file);
		const aliasedSignedUrl = getAliasSignedUrl(signedUrl);
		const xhr = new window.XMLHttpRequest();
		xhr.open('PUT', signedUrl, true);
		xhr.onprogress = evt => {
			if (evt.lengthComputable) {
				// evt.loaded the bytes the browser received
				// evt.total the total bytes set by the header
				// jQuery UI progress bar to show the progress on screen
				var percent = (evt.loaded / evt.total) * 100;
				onProgress({ percent });
			} else {
				onProgress({ percent: 100 });
			}
		};
		xhr.onload = () => {
			const status = xhr.status;
			if (status === 200) {
				console.log('Uploaded', file.name);
				onProgress({ percent: 100 });
				onSuccess(
					{
						aliasedSignedUrl,
						file,
					},
					xhr
				);
				if (callback) {
					callback(aliasedSignedUrl, file);
				}
			} else {
				onError(new Error(`Upload failed with status ${status}`));
			}
		};
		xhr.onerror = err => {
			console.error('xhr.onerror', err);
			console.error('xhr', xhr);
			onError(err);
		};
		xhr.setRequestHeader('Content-Type', file.type);
		xhr.setRequestHeader('Cache-Control', 'public, max-age=0');
		xhr.send(file);
	} catch (e) {
		console.error(e);
		console.error('error in imgCustomReq');
	}
};

export const capitalizeString = str => {
	if (str && str.length > 0) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	return str;
};

export const stylePropValidator = (key, val) => {
	const styleProps = {
		textAlign: ['auto', 'left', 'right', 'center', 'justify'],
		fontWeight: ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'],
		alignContent: ['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around'],
		alignItems: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
		alignSelf: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
		flexDirection: ['row', 'row-reverse', 'column', 'column-reverse'],
		justifyContent: [
			'flex-start',
			'flex-end',
			'center',
			'stretch',
			'space-between',
			'space-around',
		],
		resizeMode: ['cover', 'contain', 'stretch', 'repeat', 'center'],
		textTransform: ['none', 'uppercase', 'lowercase', 'capitalize'],
	};
	if (styleProps[key]) {
		const lowerCaseVal = val.toLowerCase();
		const foundVal = styleProps[key].filter(str => str === lowerCaseVal)[0];
		if (foundVal) return [key, String(foundVal)];
		return false;
	}
	return [key, String(val)];
};

export const getUrlFromHtmlScript = htmlString => {
	try {
		return htmlString.split('src=')[1].split(/'|"/)[1];
	} catch (error) {
		return null;
	}
};

export const hexToRGB = (h, opacity) => {
	try {
		let r = 0,
			g = 0,
			b = 0,
			a = opacity ? opacity : 1;

		if (h && h.length === 4) {
			r = '0x' + h[1] + h[1];
			g = '0x' + h[2] + h[2];
			b = '0x' + h[3] + h[3];
		} else if (h && h.length === 7) {
			r = '0x' + h[1] + h[2];
			g = '0x' + h[3] + h[4];
			b = '0x' + h[5] + h[6];
		}

		return 'rgba(' + +r + ',' + +g + ',' + +b + ',' + +a + ')';
	} catch (error) {
		console.error(error);
	}
};

export const validateNum = num => {
	const value = !num ? 0 : typeof num === 'string' ? num.trim() : num;
	const res = /^[0-9]+$/.test(value);
	return res;
};

export const tryParse = jsonStr => {
	if (typeof jsonStr === 'string') {
		try {
			return JSON.parse(jsonStr);
		} catch (error) {
			return jsonStr;
		}
	} else {
		return jsonStr;
	}
};

export const getLinkTarget = strOrObj => {
	// SWAN: transitioning from string onPress to obj onPress -- can remove string check after a while
	let linkTarget = '';
	const parsedStrOrObj = tryParse(strOrObj) || {};
	if (typeof parsedStrOrObj === 'string') {
		console.log('🚨 onPress has the wrong format 🚨', strOrObj, parsedStrOrObj);
		if (strOrObj && strOrObj.startsWith('/')) linkTarget = strOrObj;
	} else {
		if (parsedStrOrObj.link || parsedStrOrObj.route)
			linkTarget = parsedStrOrObj.link || parsedStrOrObj.route;
		else if (parsedStrOrObj.eventID) linkTarget = `Event ID #${parsedStrOrObj.eventID}`;
	}
	return linkTarget;
};

export const displayEmail = email => {
	const parts = email.split('@');
	return email.length > 22 && parts.length === 2 ? (
		<div>
			{parts[0]}
			<wbr />@{parts[1]}
		</div>
	) : (
		<div>{email}</div>
	);
};

// reducer to reset default colors if color input is saved as empty
export const defaultColorsReducer = (obj, defaultsObj) =>
	Object.entries(obj).reduce((updatedObj, [key, val]) => {
		if (defaultsObj[key] && !val) updatedObj[key] = defaultsObj[key];
		else updatedObj[key] = val;
		return updatedObj;
	}, {});

export const sortMedia = (media, sortOrder) => {
	const currTime = new Date().toISOString();
	switch (sortOrder) {
		case 'lastUpdated':
			return media.sort((a, b) =>
				b.updated_at
					? b.updated_at.localeCompare(a.updated_at)
					: currTime.localeCompare(a.updated_at)
			);
		case 'lastAdded':
			return media.sort((a, b) =>
				b.created_at
					? b.created_at.localeCompare(a.created_at)
					: currTime.localeCompare(a.updated_at)
			);
		case 'alpha':
			return media.sort((a, b) => a.name.localeCompare(b.name));
		case 'type':
			return media.sort((a, b) => a.mime_type.localeCompare(b.mime_type));
		default:
			return media;
	}
};

export const getHeaders = () => {
	const { auth0Token } = store.getState().auth;
	return {
		headers: {
			'0Authorization': `Bearer ${auth0Token}`,
			'Content-Type': 'application/json',
		},
	};
};

export const captureEvent = (event, properties = {}) => {
	posthog.capture(event, properties);
};

export const formatTime = time => {
	const s = Math.ceil(time % 60);
	const hr = Math.floor(time / 3600);
	const min = Math.floor((time % 3600) / 60);

	return !min ? `${s}s` : `${hr ? hr + 'h ' : ''}${min}m`;
};

export const sortBuildNumbers = (buildNumbers, desc = false) => {
	return buildNumbers.sort((a, b) => {
		const partsA = a.split('.').map(Number);
		const partsB = b.split('.').map(Number);

		for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
			const partA = partsA[i] || 0;
			const partB = partsB[i] || 0;

			if (partA !== partB) {
				return desc ? partB - partA : partA - partB;
			}
		}
		return 0;
	});
};

export const shortenDescription = description => {
	if (description.length > 65) {
		return description.slice(0, 65) + '...';
	}
	return description;
};

export const formatDate = date => moment(date).format('ll');

/**
 * Helper function to handle lazy loading with retry.
 */
export const lazyWithReload = importer =>
	lazy(() => {
		return importer().catch(() => {
			return {
				default: () => {
					// Automatically reload the page if the there is an error
					setTimeout(() => {
						window.location.reload();
					}, 100);

					return null;
				},
			};
		});
	});

/**
 * If a marketing distinct ID is stored in local storage, this function will:
 *  1. Alias the authenticated user's ID (user.email) with the stored marketing distinct ID.
 *  2. Identify the user using the stored distinct ID so that subsequent events use it.
 *  3. Remove the stored distinct ID to avoid re-use.
 *
 * @param {Object} user - The authenticated user object; expected to have an `email` property.
 */
export function aliasAndIdentifyUserWithDistinctMarketingId({ email }) {
	const storedDistinctId = localStorage.getItem('marketingDistinctId');
	if (
		storedDistinctId &&
		typeof storedDistinctId === 'string' &&
		storedDistinctId.trim() !== '' &&
		storedDistinctId !== 'undefined'
	) {
		// Alias the authenticated user with the previously stored marketing distinct ID.
		posthog.alias(storedDistinctId, email);
		// Remove the marketing distinct ID after aliasing and identifying.
		localStorage.removeItem('marketingDistinctId');
	}
	posthog.identify(email, { email });
}
